import { create } from 'zustand';

interface NavigationState {
  sidebarOpen: boolean;
  currentPath: string;
  toggleSidebar: () => void;
  setSidebarOpen: (open: boolean) => void;
  setCurrentPath: (path: string) => void;
}

export const useNavigationStore = create<NavigationState>((set) => ({
  sidebarOpen: true,
  currentPath: '/cfo/overview',
  toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),
  setSidebarOpen: (open: boolean) => set({ sidebarOpen: open }),
  setCurrentPath: (path: string) => set({ currentPath: path }),
}));
